export default "__VITE_ASSET__vd01uqAF__"